angular.module('picmonicng').factory('tlQuestionsResource', [
  '$resource',
  function ($resource) {
    return $resource(
      '/api/v3/tl/question/:question_id/:resource',
      { question_id: '@question_id', resource: '@resource' },
      {
        update: { method: 'PUT' },
      }
    );
  },
]);
